import { FC } from 'react'

export const Facebook: FC = () => (
  <svg
    width="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0739 13.6446C11.9699 14.3036 11.6036 12.3768 11.6036 16.0625C11.6036 17.576 13.4611 16.3826 14.0097 17.0415C14.4332 17.9097 13.9975 22.7283 14.1815 24.2123C15.1658 24.4163 15.4418 24.3213 16.5199 24.316C17.6743 24.3092 17.3097 23.4702 17.3097 20.9399C17.3097 20.2584 17.3132 19.5753 17.3097 18.8938C17.3097 18.593 17.2871 18.2246 17.2941 17.9357C17.2958 17.8527 17.3097 17.5604 17.3271 17.4894C17.5336 16.5676 18.2767 16.9568 19.7903 16.8011L20.1983 14.4039C20.2053 13.2468 18.6515 13.9317 17.3374 13.674C17.2507 12.0966 17.0579 10.796 18.4693 10.6179C20.0819 10.4121 20.5437 11.5778 20.273 7.96817C13.3673 6.93908 14.5252 10.5988 14.0739 13.6428V13.6446Z"
      fill="currentColor"
    />
  </svg>
)
